export const RADIO_ICON_CLASS = 'MvRadio-icon';
export const RADIO_BORDER_CLASS = 'MvRadio-border';
export const RADIO_FILL_CLASS = 'MvRadio-fill';
export const RADIO_DOT_CLASS = 'MvRadio-dot';

export const RADIO_ICON_PX = { medium: 20, small: 16 } as const;

const RADIO_DOT_PX = { medium: 10, small: 8 } as const;
const BORDER_WIDTH_PX = 1;

type RadioIconSize = keyof typeof RADIO_ICON_PX;

interface RadioIconProps {
  checked?: boolean;
  fontSize?: string;
}

const RadioIcon = ({ checked, fontSize }: RadioIconProps) => {
  const size: RadioIconSize = fontSize === 'small' ? 'small' : 'medium';
  const box = RADIO_ICON_PX[size];
  const center = box / 2;

  return (
    <svg
      className={RADIO_ICON_CLASS}
      width={box}
      height={box}
      viewBox={`0 0 ${box} ${box}`}
      aria-hidden="true"
      focusable="false"
    >
      <circle
        className={RADIO_BORDER_CLASS}
        cx={center}
        cy={center}
        r={center}
        fill="currentColor"
      />
      <circle
        className={RADIO_FILL_CLASS}
        cx={center}
        cy={center}
        r={center - BORDER_WIDTH_PX}
        fill="currentColor"
      />
      {checked && (
        <circle
          className={RADIO_DOT_CLASS}
          cx={center}
          cy={center}
          r={RADIO_DOT_PX[size] / 2}
          fill="currentColor"
        />
      )}
    </svg>
  );
};

export const RADIO_ICON = <RadioIcon />;
export const RADIO_CHECKED_ICON = <RadioIcon checked />;
